// src/services/reprocessing.service.js
import api from './api';

/**
 * Service for handling PDF reprocessing operations
 */
const reprocessingService = {
  /**
   * Reprocess a single delivery note page
   * @param {Object} data - The data needed for reprocessing
   * @param {string} data.documentId - The MongoDB document ID
   * @param {string} data.collectionName - The MongoDB collection name
   * @param {string} data.blobPath - The Azure Blob Storage path to the PDF
   * @param {string} data.accountName - Optional Azure Storage account name
   * @param {string} data.containerName - Optional Azure Storage container name
   * @returns {Promise<Object>} - The response with task ID
   */
  reprocessDeliveryNote: async (data) => {
    try {
      const response = await api.post('/api/reprocessing', data);
      return response.data;
    } catch (error) {
      console.error('Error reprocessing delivery note:', error);
      throw error;
    }
  },

  /**
   * Check the status of a reprocessing task
   * @param {string} taskId - The task ID to check
   * @returns {Promise<Object>} - The task status
   */
  checkReprocessingStatus: async (taskId) => {
    try {
      const response = await api.get(`/api/reprocessing/${taskId}`);
      return response.data;
    } catch (error) {
      console.error('Error checking reprocessing status:', error);
      throw error;
    }
  }
};

export default reprocessingService;
